import { ArrowRight, PartyPopper, Play } from "lucide-react";

export const UnlockedPanel = ({ onWatch }) => (
  <div className="unlocked-inline" role="status" data-testid="unlock-success">
    <p className="un-title"><PartyPopper size={22} /> You unlocked it.</p>
    <p className="core-h un-core">Your WTF idea <ArrowRight size={16} /> Consistent cash</p>
    <p className="un-h">Your free class is ready.</p>
    <p className="un-p">Watch the class and see how ONE belief-shifting idea can become your method, book/video, premium offer + AI-powered Freedom Funnel.</p>
    <button type="button" className="btn-gold" onClick={onWatch} data-testid="unlock-watch-now-button"><Play size={16} fill="currentColor" /> Watch the free class</button>
  </div>
);
